<div class="min-h-screen bg-gradient-to-br from-gray-900 via-gray-900 to-gray-800">
  <app-notification></app-notification>
  
  <div class="py-8">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <!-- Header -->
      <div class="mb-8">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <div>
              <h1 class="text-3xl font-bold text-white">Edit Product</h1>
            </div>
          </div>
          
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="flex flex-col justify-center items-center py-20">
        <div class="relative">
          <div class="animate-spin rounded-full h-16 w-16 border-4 border-indigo-500/20 border-t-indigo-500"></div>
          <div class="absolute inset-0 flex items-center justify-center">
            <div class="h-8 w-8 rounded-full bg-indigo-500/20 animate-pulse"></div>
          </div>
        </div>
        <p class="mt-4 text-sm text-gray-400">Loading product...</p>
      </div>

      <!-- Product Form -->
      <form *ngIf="!isLoading && product" [formGroup]="productForm" (ngSubmit)="saveProduct()" class="space-y-6">
        <!-- Tabs Navigation -->
        <div class="bg-gray-800/60 backdrop-blur-sm rounded-xl border border-gray-700/50 shadow-xl overflow-visible">
          <div class="border-b border-gray-700/50">
            <nav class="flex space-x-1 px-4 overflow-x-auto" aria-label="Tabs">
              <button
                type="button"
                (click)="setActiveTab('basic')"
                [class]="activeTab === 'basic' 
                  ? 'border-indigo-500 text-indigo-400 bg-indigo-500/10' 
                  : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300'"
                class="whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm transition-colors"
              >
                Basic Info
              </button>
              <button
                type="button"
                (click)="setActiveTab('names')"
                [class]="activeTab === 'names' 
                  ? 'border-indigo-500 text-indigo-400 bg-indigo-500/10' 
                  : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300'"
                class="whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm transition-colors"
              >
                Names
              </button>
              <button
                type="button"
                (click)="setActiveTab('descriptions')"
                [class]="activeTab === 'descriptions' 
                  ? 'border-indigo-500 text-indigo-400 bg-indigo-500/10' 
                  : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300'"
                class="whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm transition-colors"
              >
                Descriptions
              </button>
              <button
                type="button"
                (click)="setActiveTab('manuals')"
                [class]="activeTab === 'manuals' 
                  ? 'border-indigo-500 text-indigo-400 bg-indigo-500/10' 
                  : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300'"
                class="whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm transition-colors"
              >
                Manuals
              </button>
              <button
                type="button"
                (click)="setActiveTab('faq')"
                [class]="activeTab === 'faq' 
                  ? 'border-indigo-500 text-indigo-400 bg-indigo-500/10' 
                  : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300'"
                class="whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm transition-colors"
              >
                FAQ
              </button>
              <button
                type="button"
                (click)="setActiveTab('seo')"
                [class]="activeTab === 'seo' 
                  ? 'border-indigo-500 text-indigo-400 bg-indigo-500/10' 
                  : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300'"
                class="whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm transition-colors"
              >
                SEO
              </button>
              <button
                type="button"
                (click)="setActiveTab('categories')"
                [class]="activeTab === 'categories' 
                  ? 'border-indigo-500 text-indigo-400 bg-indigo-500/10' 
                  : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300'"
                class="whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm transition-colors"
              >
                Categories
              </button>
              <button
                type="button"
                (click)="setActiveTab('pricing')"
                [class]="activeTab === 'pricing' 
                  ? 'border-indigo-500 text-indigo-400 bg-indigo-500/10' 
                  : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300'"
                class="whitespace-nowrap py-4 px-4 border-b-2 font-medium text-sm transition-colors"
              >
                Pricing
              </button>
            </nav>
          </div>

          <!-- Tab Content -->
          <div class="p-6">
            <!-- Language Selector (shown for language tabs) -->
            <div *ngIf="activeTab !== 'basic' && activeTab !== 'pricing' && activeTab !== 'categories'" class="mb-6 bg-gray-900/50 rounded-lg border border-gray-700/50 p-4">
              <div class="flex items-center justify-between mb-4">
                <div class="flex items-center space-x-3">
                  <h3 class="text-sm font-semibold text-white">Select Languages</h3>
                </div>
                <button
                  type="button"
                  (click)="showLanguageSelector = !showLanguageSelector"
                  class="text-gray-400 hover:text-gray-300 transition-colors"
                >
                  <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="showLanguageSelector ? 'M5 15l7-7 7 7' : 'M19 9l-7 7-7-7'" />
                  </svg>
                </button>
              </div>
              <div *ngIf="showLanguageSelector" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
                <div *ngFor="let lang of languages" class="flex items-center space-x-2 p-3 rounded-lg border border-gray-700/50 hover:bg-gray-800/50 cursor-pointer transition-colors" [ngClass]="{'bg-indigo-500/20': isLanguageSelected(lang), 'border-indigo-500': isLanguageSelected(lang)}">
                  <input
                    type="checkbox"
                    [checked]="isLanguageSelected(lang)"
                    (change)="toggleLanguage(lang)"
                    [id]="'lang-checkbox-cat-' + lang"
                    class="rounded border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-offset-0"
                  />
                  <label [attr.for]="'lang-checkbox-cat-' + lang" class="text-sm text-gray-300 cursor-pointer">{{ languageNames[lang] }}</label>
                </div>
              </div>
              <div *ngIf="!showLanguageSelector" class="flex flex-wrap gap-2">
                <span *ngFor="let lang of selectedLanguages" class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-indigo-500/20 text-indigo-300 border border-indigo-500/30">
                  {{ languageNames[lang] }}
                </span>
                <span *ngIf="selectedLanguages.length === 0" class="text-sm text-gray-400">No languages selected</span>
              </div>
            </div>

            <!-- Basic Info Tab -->
            <div *ngIf="activeTab === 'basic'" class="space-y-6">
              <!-- Product Images Gallery -->
              <div class="bg-gray-900/50 rounded-lg border border-gray-700/50 p-4">
                <div class="flex items-center justify-between mb-4">
                  <h3 class="text-sm font-semibold text-white">Productafbeeldingen</h3>
                  <div class="flex gap-2">
                    <button type="button" (click)="showMediaSelector = true"
                      class="inline-flex items-center px-3 py-1.5 text-xs font-medium text-indigo-300 bg-indigo-900/30 border border-indigo-700/50 rounded-lg hover:bg-indigo-900/50 transition-colors">
                      <svg class="h-3.5 w-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      Uit media
                    </button>
                    <label class="inline-flex items-center px-3 py-1.5 text-xs font-medium text-purple-300 bg-purple-900/30 border border-purple-700/50 rounded-lg hover:bg-purple-900/50 transition-colors cursor-pointer">
                      <svg *ngIf="!imageUploading" class="h-3.5 w-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                      </svg>
                      <svg *ngIf="imageUploading" class="animate-spin h-3.5 w-3.5 mr-1" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      {{ imageUploading ? imageUploadProgress + '%' : 'Upload' }}
                      <input type="file" accept="image/*" multiple (change)="uploadImage($event)" class="hidden" [disabled]="imageUploading" />
                    </label>
                  </div>
                </div>

                <!-- Image Grid -->
                <div *ngIf="productImages.length > 0" class="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 gap-3">
                  <div *ngFor="let img of productImages; let i = index"
                    class="relative group aspect-square rounded-lg overflow-hidden border-2 transition-all cursor-pointer"
                    [ngClass]="i === primaryImageIndex ? 'border-indigo-500 ring-2 ring-indigo-500/30' : 'border-gray-700 hover:border-gray-500'"
                    (click)="setPrimaryImage(i)">
                    <img [src]="img.src" alt="Product" class="w-full h-full object-cover">
                    <!-- Primary badge -->
                    <div *ngIf="i === primaryImageIndex"
                      class="absolute top-1 left-1 px-1.5 py-0.5 bg-indigo-600 text-white text-[10px] font-bold rounded">
                      Primair
                    </div>
                    <!-- Actions overlay -->
                    <div class="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all flex items-center justify-center gap-1 opacity-0 group-hover:opacity-100">
                      <button *ngIf="i > 0" type="button" (click)="moveImageLeft(i); $event.stopPropagation()"
                        class="p-1 bg-gray-900/80 rounded text-gray-300 hover:text-white" title="Naar links">
                        <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>
                      </button>
                      <button *ngIf="i < productImages.length - 1" type="button" (click)="moveImageRight(i); $event.stopPropagation()"
                        class="p-1 bg-gray-900/80 rounded text-gray-300 hover:text-white" title="Naar rechts">
                        <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/></svg>
                      </button>
                      <button type="button" (click)="removeImage(i); $event.stopPropagation()"
                        class="p-1 bg-red-900/80 rounded text-red-300 hover:text-white" title="Verwijderen">
                        <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Empty state -->
                <div *ngIf="productImages.length === 0 && !imageUploading"
                  class="flex flex-col items-center justify-center py-8 border-2 border-dashed border-gray-700 rounded-lg">
                  <svg class="h-10 w-10 text-gray-600 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <p class="text-xs text-gray-500">Nog geen afbeeldingen. Upload of selecteer uit de media bibliotheek.</p>
                </div>

                <p *ngIf="productImages.length > 1" class="text-[10px] text-gray-500 mt-2">Klik op een afbeelding om deze als primair in te stellen. De primaire afbeelding wordt als eerste getoond in de shop.</p>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label class="text-sm font-medium text-gray-300 mb-2">
                    SKU
                  </label>
                  <input
                    type="text"
                    formControlName="sku"
                    placeholder="Enter product SKU"
                    class="block w-full rounded-lg border-gray-600 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2.5"
                  />
                </div>

                <div>
                  <label class="text-sm font-medium text-gray-300 mb-2">
                    Status
                  </label>
                  <select
                    formControlName="status"
                    class="block w-full rounded-lg border-gray-600 bg-gray-700/50 text-white focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2.5"
                  >
                    <option value="publish">Gepubliceerd</option>
                    <option value="draft">Concept</option>
                    <option value="private">Privé</option>
                    <option value="unpublished">Niet gepubliceerd</option>
                  </select>
                </div>

                <div>
                  <div class="flex items-center justify-between mb-2">
                    <label class="text-sm font-medium text-gray-300">
                      Price (€) <span class="text-red-400 ml-1">*</span>
                    </label>
                    <label class="flex items-center space-x-2 cursor-pointer group">
                      <div class="relative flex items-center justify-center">
                        <input
                          type="checkbox"
                          formControlName="on_sale"
                          class="sr-only peer"
                        />
                        <div class="w-5 h-5 rounded border-2 border-gray-600 bg-gray-700/50 peer-checked:bg-indigo-600 peer-checked:border-indigo-600 peer-focus:ring-2 peer-focus:ring-indigo-500/50 peer-focus:ring-offset-2 peer-focus:ring-offset-gray-800 transition-all duration-200 flex items-center justify-center">
                          <svg class="w-3 h-3 text-white opacity-0 peer-checked:opacity-100 transition-opacity duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                          </svg>
                        </div>
                      </div>
                      <span class="text-sm font-medium text-gray-300 group-hover:text-white transition-colors">Product on Sale</span>
                    </label>
                  </div>
                  <div class="relative">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <span class="text-gray-400 sm:text-sm">€</span>
                    </div>
                    <input
                      type="number"
                      formControlName="price"
                      step="0.01"
                      min="0"
                      placeholder="0.00"
                      class="block w-full pl-8 pr-4 py-2.5 rounded-lg border-gray-600 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm"
                    />
                  </div>
                  <div *ngIf="productForm.get('on_sale')?.value" class="mt-2 transition-all duration-200 ease-in-out space-y-2">
                    <label class="block text-sm font-medium text-gray-300 mb-2">Sale Price (€)</label>
                    <div class="relative">
                      <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <span class="text-gray-400 sm:text-sm">€</span>
                      </div>
                      <input
                        type="number"
                        formControlName="sale_price"
                        step="0.01"
                        min="0"
                        placeholder="0.00"
                        class="block w-full pl-8 pr-4 py-2.5 rounded-lg border-indigo-500/50 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm"
                      />
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <div>
                        <label class="block text-sm font-medium text-gray-300 mb-2">Sale From</label>
                        <input
                          type="date"
                          formControlName="saleFrom"
                          class="block w-full rounded-lg border-indigo-500/50 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2.5"
                        />
                      </div>
                      <div>
                        <label class="block text-sm font-medium text-gray-300 mb-2">Sale To</label>
                        <input
                          type="date"
                          formControlName="saleTo"
                          class="block w-full rounded-lg border-indigo-500/50 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2.5"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <label class="text-sm font-medium text-gray-300 mb-2">
                    Stock Quantity <span class="text-red-400 ml-1">*</span>
                  </label>
                  <input
                    type="number"
                    formControlName="stock_quantity"
                    min="0"
                    placeholder="0"
                    class="block w-full rounded-lg border-gray-600 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2.5"
                  />
                </div>

                <div>
                  <label class="text-sm font-medium text-gray-300 mb-2">
                    Stock Status <span class="text-red-400 ml-1">*</span>
                  </label>
                  <select
                    formControlName="stock_status"
                    class="block w-full rounded-lg border-gray-600 bg-gray-700/50 text-white focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2.5"
                  >
                    <option value="instock">Op voorraad</option>
                    <option value="outofstock">Uitverkocht</option>
                    <option value="onbackorder">In bestelling</option>
                  </select>
                </div>

                <div>
                  <label class="text-sm font-medium text-gray-300 mb-2">
                    Weight (kg)
                  </label>
                  <input
                    type="number"
                    formControlName="weight"
                    step="0.1"
                    min="0"
                    placeholder="0"
                    class="block w-full rounded-lg border-gray-600 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2.5"
                  />
                </div>
              </div>
            </div>

            <!-- Names Tab -->
            <div *ngIf="activeTab === 'names'" class="space-y-6">
              <div *ngFor="let lang of selectedLanguages" class="bg-gray-900/50 rounded-lg border border-gray-700/50 p-4">
                <h3 class="text-sm font-semibold text-white mb-4">
                  {{ languageNames[lang] }} ({{ lang.toUpperCase() }})
                </h3>
                <div>
                  <label class="block text-sm font-medium text-gray-300 mb-2">Product Name</label>
                  <input
                    type="text"
                    [value]="getAcfField('naam', lang)"
                    (input)="setAcfField('naam', lang, $any($event.target).value)"
                    [placeholder]="'Enter product name in ' + languageNames[lang]"
                    class="block w-full rounded-lg border-gray-600 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2.5"
                  />
                </div>
              </div>
            </div>

            <!-- Descriptions Tab -->
            <div *ngIf="activeTab === 'descriptions'" class="space-y-6">
              <div *ngFor="let lang of selectedLanguages" class="bg-gray-900/50 rounded-lg border border-gray-700/50 p-4">
                <h3 class="text-sm font-semibold text-white mb-4">
                  {{ languageNames[lang] }} ({{ lang.toUpperCase() }})
                </h3>
                <div>
                  <label class="block text-sm font-medium text-gray-300 mb-2">Description</label>
                  <editor
                    [(ngModel)]="acfFields['omschrijving_' + lang]"
                    [ngModelOptions]="{standalone: true}"
                    [init]="editorConfig"
                    class="w-full"
                  ></editor>
                </div>
              </div>
            </div>

            <!-- Manuals Tab -->
            <div *ngIf="activeTab === 'manuals'" class="space-y-6">
              <div *ngFor="let lang of selectedLanguages" class="bg-gray-900/50 rounded-lg border border-gray-700/50 p-4">
                <h3 class="text-sm font-semibold text-white mb-4">
                  {{ languageNames[lang] }} ({{ lang.toUpperCase() }})
                </h3>
                <div>
                  <label class="block text-sm font-medium text-gray-300 mb-2">Manual / Instructions</label>
                  <editor
                    [(ngModel)]="acfFields['handleiding_' + lang]"
                    [ngModelOptions]="{standalone: true}"
                    [init]="editorConfig"
                    class="w-full"
                  ></editor>
                </div>
              </div>
            </div>

            <!-- FAQ Tab -->
            <div *ngIf="activeTab === 'faq'" class="space-y-6">
              <div *ngFor="let lang of selectedLanguages" class="bg-gray-900/50 rounded-lg border border-gray-700/50 p-4">
                <h3 class="text-sm font-semibold text-white mb-4">
                  {{ languageNames[lang] }} ({{ lang.toUpperCase() }})
                </h3>
                <div>
                  <label class="block text-sm font-medium text-gray-300 mb-2">Frequently Asked Questions</label>
                  <editor
                    [(ngModel)]="acfFields['veelgestelde_vragen_' + lang]"
                    [ngModelOptions]="{standalone: true}"
                    [init]="editorConfig"
                    class="w-full"
                  ></editor>
                </div>
              </div>
            </div>

            <!-- SEO Tab -->
            <div *ngIf="activeTab === 'seo'" class="space-y-6">
              <div *ngFor="let lang of selectedLanguages" class="bg-gray-900/50 rounded-lg border border-gray-700/50 p-4">
                <h3 class="text-sm font-semibold text-white mb-4">
                  {{ languageNames[lang] }} ({{ lang.toUpperCase() }})
                </h3>
                <div class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-2">Meta Title</label>
                    <input
                      type="text"
                      [value]="getSeoField('meta_title', lang)"
                      (input)="setSeoField('meta_title', lang, $any($event.target).value)"
                      [placeholder]="'Enter meta title in ' + languageNames[lang]"
                      class="block w-full rounded-lg border-gray-600 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2.5"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-2">Meta Description</label>
                    <textarea
                      [value]="getSeoField('meta_desc', lang)"
                      (input)="setSeoField('meta_desc', lang, $any($event.target).value)"
                      [placeholder]="'Enter meta description in ' + languageNames[lang]"
                      rows="3"
                      class="block w-full rounded-lg border-gray-600 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2.5"
                    ></textarea>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-300 mb-2">URL Slug</label>
                    <input
                      type="text"
                      [value]="getAcfField('slug', lang)"
                      (input)="setAcfField('slug', lang, $any($event.target).value)"
                      [placeholder]="'Enter URL slug in ' + languageNames[lang]"
                      class="block w-full rounded-lg border-gray-600 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2.5"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- Categories Tab -->
            <div *ngIf="activeTab === 'categories'" class="space-y-6">
              <!-- Language Selector for Categories -->
              <div class="mb-6 bg-gray-900/50 rounded-lg border border-gray-700/50 p-4">
                <div class="flex items-center justify-between mb-4">
                  <div class="flex items-center space-x-3">
                    <h3 class="text-sm font-semibold text-white">Select Languages</h3>
                  </div>
                  <button
                    type="button"
                    (click)="showLanguageSelector = !showLanguageSelector"
                    class="text-gray-400 hover:text-gray-300 transition-colors"
                  >
                    <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="showLanguageSelector ? 'M5 15l7-7 7 7' : 'M19 9l-7 7-7-7'" />
                    </svg>
                  </button>
                </div>
                <div *ngIf="showLanguageSelector" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
                  <div *ngFor="let lang of languages" class="flex items-center space-x-2 p-3 rounded-lg border border-gray-700/50 hover:bg-gray-800/50 cursor-pointer transition-colors" [ngClass]="{'bg-indigo-500/20': isLanguageSelected(lang), 'border-indigo-500': isLanguageSelected(lang)}">
                    <input
                      type="checkbox"
                      [checked]="isLanguageSelected(lang)"
                      (change)="toggleLanguage(lang)"
                      [id]="'lang-checkbox-' + lang"
                      class="rounded border-gray-600 text-indigo-600 focus:ring-indigo-500 focus:ring-offset-0"
                    />
                    <label [attr.for]="'lang-checkbox-' + lang" class="text-sm text-gray-300 cursor-pointer">{{ languageNames[lang] }}</label>
                  </div>
                </div>
                <div *ngIf="!showLanguageSelector" class="flex flex-wrap gap-2">
                  <span *ngFor="let lang of selectedLanguages" class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-indigo-500/20 text-indigo-300 border border-indigo-500/30">
                    {{ languageNames[lang] }}
                  </span>
                  <span *ngIf="selectedLanguages.length === 0" class="text-sm text-gray-400">No languages selected</span>
                </div>
              </div>
              <div class="bg-gray-900/50 rounded-lg border border-gray-700/50 p-4">
                <h3 class="text-sm font-semibold text-white mb-4">Category Information</h3>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div *ngFor="let lang of selectedLanguages">
                    <label class="block text-sm font-medium text-gray-300 mb-2">{{ languageNames[lang] }} ({{ lang.toUpperCase() }})</label>
                    <div class="space-y-3">
                      <div class="relative">
                        <label class="block text-xs text-gray-400 mb-1">Main Category</label>
                        <input
                          type="text"
                          [value]="getCategoryField('main_cat', lang)"
                          (input)="onCategoryInput(lang, $any($event.target).value)"
                          (focus)="onCategoryFocus(lang)"
                          (blur)="onCategoryBlur(lang)"
                          placeholder="Zoek of typ categorie..."
                          autocomplete="off"
                          class="block w-full rounded-lg border-gray-600 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2"
                        />
                        <div
                          *ngIf="categoryDropdownOpen[lang] && getFilteredCategories(lang).length > 0"
                          class="absolute z-50 mt-1 w-full max-h-64 overflow-y-auto bg-gray-800 border border-gray-600 rounded-lg shadow-xl"
                        >
                          <button
                            *ngFor="let item of getFilteredCategories(lang)"
                            type="button"
                            (mousedown)="selectCategory(lang, item.category)"
                            class="w-full text-left py-2 pr-4 text-sm text-gray-300 hover:bg-indigo-600/30 hover:text-white transition-colors"
                            [style.padding-left.rem]="1 + item.depth * 1"
                          >
                            <span *ngIf="item.depth > 0" class="text-gray-500 mr-1">└</span>{{ item.category.name }}
                          </button>
                        </div>
                      </div>
                      <div>
                        <label class="block text-xs text-gray-400 mb-1">URL</label>
                        <input
                          type="text"
                          [value]="getCategoryField('url', lang)"
                          (input)="setCategoryField('url', lang, $any($event.target).value)"
                          placeholder="/path/to/product"
                          class="block w-full rounded-lg border-gray-600 bg-gray-700/50 text-white placeholder-gray-500 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/50 focus:bg-gray-700 transition-all duration-200 sm:text-sm px-4 py-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Pricing Tab -->
            <div *ngIf="activeTab === 'pricing'" class="space-y-6">
              <div class="bg-gray-900/50 rounded-lg border border-gray-700/50 p-4">
                <div class="flex items-center justify-between mb-4">
                  <h3 class="text-sm font-semibold text-white">Price Options</h3>
                  <button
                    type="button"
                    (click)="addPriceOption()"
                    class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 shadow-lg transition-all duration-200"
                  >
                    <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                    </svg>
                    Add Price Option
                  </button>
                </div>

                <div *ngIf="priceOptions.length === 0" class="text-center py-12 border-2 border-dashed border-gray-700 rounded-lg bg-gray-900/30">
                  <svg class="mx-auto h-12 w-12 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                  </svg>
                  <p class="mt-4 text-sm text-gray-400">No price options yet</p>
                  <p class="mt-1 text-xs text-gray-500">Click "Add Price Option" to create one</p>
                </div>

                <div *ngIf="priceOptions.length > 0" class="space-y-3">
                  <div *ngFor="let option of priceOptions; let i = index; trackBy: trackByIndex"
                    class="rounded-lg border transition-all duration-200"
                    [ngClass]="option.enabled !== false ? 'bg-gray-800/50 border-gray-700/50 hover:border-gray-600/50' : 'bg-gray-900/30 border-gray-800/50 opacity-60'">
                    <!-- Header row -->
                    <div class="flex items-center gap-3 px-4 py-3 border-b border-gray-700/30">
                      <label class="relative inline-flex items-center cursor-pointer flex-shrink-0">
                        <input type="checkbox" [checked]="option.enabled !== false" (change)="togglePriceOption(i)"
                          class="sr-only peer">
                        <div class="w-8 h-4 bg-gray-600 peer-focus:ring-2 peer-focus:ring-indigo-500/30 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:bg-indigo-600"></div>
                      </label>
                      <span class="text-xs font-medium text-gray-400">#{{ i + 1 }}</span>
                      <span class="text-sm font-medium text-white flex-1 truncate">{{ option.name_nl || option.name || 'Naamloos' }}</span>
                      <span class="text-xs text-gray-500 font-mono">€{{ option.price }}</span>
                      <span class="text-[10px] px-1.5 py-0.5 rounded-full"
                        [ngClass]="option.stock_status !== 'outofstock' ? 'bg-green-900/30 text-green-400' : 'bg-red-900/30 text-red-400'">
                        {{ option.stock_status !== 'outofstock' ? (option.stock_quantity || 0) + ' op voorraad' : 'Uitverkocht' }}
                      </span>
                      <button type="button" (click)="removePriceOption(i)"
                        class="p-1 text-gray-500 hover:text-red-400 transition-colors" title="Verwijderen">
                        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                    <!-- Detail fields -->
                    <div class="px-4 py-3 space-y-3">
                      <!-- Names row -->
                      <div class="grid grid-cols-2 md:grid-cols-3 gap-3">
                        <div *ngFor="let lang of selectedLanguages">
                          <label class="block text-[10px] text-gray-500 mb-1 uppercase">Naam {{ lang }}</label>
                          <input type="text"
                            [(ngModel)]="$any(option)['name_' + lang]"
                            [ngModelOptions]="{standalone: true}"
                            placeholder="Optie naam"
                            class="block w-full rounded-md border-gray-600 bg-gray-700/50 text-white text-sm px-3 py-1.5 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/50">
                        </div>
                      </div>
                      <!-- Price + Stock row -->
                      <div class="grid grid-cols-3 gap-3">
                        <div>
                          <label class="block text-[10px] text-gray-500 mb-1 uppercase">Prijs</label>
                          <div class="relative">
                            <span class="absolute inset-y-0 left-0 pl-2.5 flex items-center text-gray-400 text-xs">€</span>
                            <input type="number" [(ngModel)]="option.price" [ngModelOptions]="{standalone: true}"
                              step="0.01" min="0" placeholder="0.00"
                              class="block w-full pl-7 pr-3 py-1.5 rounded-md border-gray-600 bg-gray-700/50 text-white text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/50">
                          </div>
                        </div>
                        <div>
                          <label class="block text-[10px] text-gray-500 mb-1 uppercase">Voorraad</label>
                          <input type="number" [(ngModel)]="option.stock_quantity" [ngModelOptions]="{standalone: true}"
                            min="0" placeholder="0"
                            class="block w-full px-3 py-1.5 rounded-md border-gray-600 bg-gray-700/50 text-white text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/50">
                        </div>
                        <div>
                          <label class="block text-[10px] text-gray-500 mb-1 uppercase">Status</label>
                          <select [(ngModel)]="option.stock_status" [ngModelOptions]="{standalone: true}"
                            class="block w-full px-3 py-1.5 rounded-md border-gray-600 bg-gray-700/50 text-white text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/50">
                            <option value="instock">Op voorraad</option>
                            <option value="outofstock">Uitverkocht</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex items-center justify-end space-x-3 pt-6 border-t border-gray-700/50">
          <a *ngIf="previewUrl"
            [href]="previewUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center px-5 py-2.5 border border-gray-700 rounded-lg text-sm font-medium text-gray-300 hover:text-white hover:border-gray-500 transition-all duration-200"
            title="Open preview op Vercel met domein-override (geen cache)">
            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            Bekijk preview
          </a>
          <button
            type="button"
            (click)="cancel()"
            class="inline-flex items-center px-5 py-2.5 border border-gray-700 rounded-lg shadow-sm text-sm font-medium text-gray-300 bg-gray-800/50 backdrop-blur-sm hover:bg-gray-700/50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all duration-200"
          >
            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            Cancel
          </button>
          <button
            type="submit"
            [disabled]="productForm.invalid || isSaving"
            class="inline-flex items-center px-5 py-2.5 border border-indigo-500/50 rounded-lg text-sm font-medium text-indigo-300 bg-indigo-900/30 hover:bg-indigo-900/50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
          >
            <svg *ngIf="!isSaving" class="h-4 w-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
            <svg *ngIf="isSaving" class="animate-spin h-4 w-4 mr-1.5" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ isSaving ? 'Opslaan...' : 'Opslaan' }}
          </button>
          <button
            type="button"
            (click)="saveAndClose()"
            [disabled]="productForm.invalid || isSaving"
            class="inline-flex items-center px-5 py-2.5 border border-transparent rounded-lg shadow-lg text-sm font-medium text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
          >
            <svg *ngIf="!isSaving" class="h-4 w-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
            Opslaan &amp; sluiten
          </button>
        </div>
      </form>

      <!-- Media Selector Modal -->
      <app-media-selector-modal
        [show]="showMediaSelector"
        (onSelect)="onImageSelected($event)"
        (onClose)="showMediaSelector = false"
      ></app-media-selector-modal>
    </div>
  </div>
</div>